"use strict";var EventEmitter = require("events-light");
var vdom = require("./vdom");
var VElement = vdom.aZ_;
var VDocumentFragment = vdom.b__;
var VText = vdom.ba_;
var VComponent = vdom.bb_;
var VFragment = vdom.bc_;
var virtualizeHTML = vdom.bd_;
var RenderResult = require("../RenderResult");
var morphdom = require("./morphdom");
var attrsHelper = require("./helpers/attrs");

var EVENT_UPDATE = "update";
var EVENT_FINISH = "finish";

function State(tree) {
  this.be_ = new EventEmitter();
  this.bf_ = tree;
  this.bg_ = false;
}

function AsyncVDOMBuilder(globalData, parentNode, parentOut) {
  if (!parentNode) {
    parentNode = new VDocumentFragment();
  }

  var state;

  if (parentOut) {
    state = parentOut.K_;
  } else {
    state = new State(parentNode);
  }

  this.bh_ = 1;
  this.bi_ = 0;
  this.bj_ = null;
  this.bk_ = parentOut;

  this.data = {};
  this.K_ = state;
  this.m_ = parentNode;
  this.global = globalData || {};
  this.bl_ = [parentNode];
  this.bm_ = false;
  this.bn_ = undefined;
  this.b_ = null;

  this.h_ = null;
  this.j_ = null;
  this.av_ = null;
}

var proto = AsyncVDOMBuilder.prototype = {
  aO_: true,
  Y_: typeof document === "object" && document,

  bc: function (component, key, ownerComponent) {
    var vComponent = new VComponent(component, key, ownerComponent);
    return this.bo_(vComponent, 0, true);
  },

  aw_: function (component, key, ownerComponent) {
    var vComponent = new VComponent(component, key, ownerComponent, true);
    this.bo_(vComponent, 0);
  },

  bo_: function (child, childCount, pushToStack) {
    this.m_.bp_(child);
    if (pushToStack === true) {
      this.bl_.push(child);
      this.m_ = child;
    }
    return childCount === 0 ? this : child;
  },

  element: function (tagName, attrs, key, component, childCount, flags, props) {
    var element = new VElement(
    tagName,
    attrs,
    key,
    component,
    childCount,
    flags,
    props);

    return this.bo_(element, childCount);
  },

  aL_: function (tagName, attrs, key, componentDef, props) {
    return this.element(
    tagName,
    attrsHelper(attrs),
    key,
    componentDef.i_,
    0,
    0,
    props);

  },

  n: function (node, component) {
    // NOTE: We do a shallow clone since we assume the node is being reused
    //       and a node can only have one parent node.
    var clone = node.bq_();
    this.node(clone);
    clone.az_ = component;

    return this;
  },

  node: function (node) {
    this.m_.bp_(node);
    return this;
  },

  text: function (text, ownerComponent) {
    var type = typeof text;

    if (type != "string") {
      if (text == null) {
        return;
      } else if (type === "object") {
        if (text.toHTML) {
          return this.h(text.toHTML(), ownerComponent);
        }
      }

      text = text.toString();
    }

    this.m_.bp_(new VText(text, ownerComponent));
    return this;
  },

  html: function (html, ownerComponent) {
    if (html != null) {
      var vdomNode = virtualizeHTML(html, ownerComponent);
      this.node(vdomNode);
    }

    return this;
  },

  beginElement: function (
  tagName,
  attrs,
  key,
  component,
  childCount,
  flags,
  props)
  {
    var element = new VElement(
    tagName,
    attrs,
    key,
    component,
    childCount,
    flags,
    props);

    this.bo_(element, childCount, true);
    return this;
  },

  aJ_: function (tagName, attrs, key, componentDef, props) {
    return this.beginElement(
    tagName,
    attrsHelper(attrs),
    key,
    componentDef.i_,
    0,
    0,
    props);

  },

  bf: function (key, component, preserve) {
    var fragment = new VFragment(key, component, preserve);
    this.bo_(fragment, null, true);
    return this;
  },

  ef: function () {
    this.endElement();
  },

  endElement: function () {
    var stack = this.bl_;
    stack.pop();
    this.m_ = stack[stack.length - 1];
  },

  end: function () {
    this.m_ = undefined;

    var remaining = --this.bh_;
    var parentOut = this.bk_;

    if (remaining === 0) {
      if (parentOut) {
        parentOut.br_();
      } else {
        this.bs_();
      }
    } else if (remaining - this.bi_ === 0) {
      this.bt_();
    }

    return this;
  },

  br_: function () {
    var remaining = --this.bh_;

    if (remaining === 0) {
      var parentOut = this.bk_;
      if (parentOut) {
        parentOut.br_();
      } else {
        this.bs_();
      }
    } else if (remaining - this.bi_ === 0) {
      this.bt_();
    }
  },

  bs_: function () {
    var state = this.K_;
    state.bg_ = true;
    state.be_.emit(EVENT_FINISH, this.aP_());
  },

  bt_: function () {
    var lastArray = this._last;

    var i = 0;

    function next() {
      if (i === lastArray.length) {
        return;
      }
      var lastCallback = lastArray[i++];
      lastCallback(next);

      if (!lastCallback.length) {
        next();
      }
    }

    next();
  },

  error: function (e) {
    try {
      this.emit("error", e);
    } finally {
      // If there is no listener for the error event then it will
      // throw a new Error here. In order to ensure that the async fragment
      // is still properly ended we need to put the end() in a `finally`
      // block
      this.end();
    }

    return this;
  },

  beginAsync: function (options) {
    if (this.bm_) {
      throw Error(
      "Tried to render async while in sync mode. Note: Client side await is not currently supported in re-renders (Issue: #942).");

    }

    var state = this.K_;

    if (options) {
      if (options.last) {
        this.bi_++;
      }
    }

    this.bh_++;

    var documentFragment = this.m_.bu_();
    var asyncOut = new AsyncVDOMBuilder(this.global, documentFragment, this);

    state.be_.emit("beginAsync", {
      out: asyncOut,
      parentOut: this
    });

    return asyncOut;
  },

  createOut: function () {
    return new AsyncVDOMBuilder(this.global);
  },

  flush: function () {
    var events = this.K_.be_;

    if (events.listenerCount(EVENT_UPDATE)) {
      events.emit(EVENT_UPDATE, new RenderResult(this));
    }
  },

  C_: function () {
    return this.K_.bf_;
  },

  aP_: function () {
    return this.bv_ || (this.bv_ = new RenderResult(this));
  },

  on: function (event, callback) {
    var state = this.K_;

    if (event === EVENT_FINISH && state.bg_) {
      callback(this.aP_());
    } else if (event === "last") {
      this.onLast(callback);
    } else {
      state.be_.on(event, callback);
    }

    return this;
  },

  once: function (event, callback) {
    var state = this.K_;

    if (event === EVENT_FINISH && state.bg_) {
      callback(this.aP_());
    } else if (event === "last") {
      this.onLast(callback);
    } else {
      state.be_.once(event, callback);
    }

    return this;
  },

  emit: function (type, arg) {
    var events = this.K_.be_;
    switch (arguments.length) {
      case 1:
        events.emit(type);
        break;
      case 2:
        events.emit(type, arg);
        break;
      default:
        events.emit.apply(events, arguments);
        break;}

    return this;
  },

  removeListener: function () {
    var events = this.K_.be_;
    events.removeListener.apply(events, arguments);
    return this;
  },

  sync: function () {
    this.bm_ = true;
  },

  isSync: function () {
    return this.bm_;
  },

  onLast: function (callback) {
    var lastArray = this._last;

    if (lastArray === undefined) {
      this._last = [callback];
    } else {
      lastArray.push(callback);
    }

    return this;
  },

  B_: function (host) {
    var node = this.bn_;
    if (!node) {
      var vdomTree = this.C_();

      if (!host) host = this.Y_;
      this.bn_ = node = vdomTree.bw_(host, null);
      morphdom(node, vdomTree, host, this.b_);
    }
    return node;
  },

  toString: function (host) {
    var docFragment = this.B_(host);
    var html = "";

    var child = docFragment.firstChild;
    while (child) {
      var nextSibling = child.nextSibling;
      if (child.nodeType != 1) {
        var container = docFragment.ownerDocument.createElement("div");
        container.appendChild(child.cloneNode());
        html += container.innerHTML;
      } else {
        html += child.outerHTML;
      }

      child = nextSibling;
    }

    return html;
  },

  then: function (fn, fnErr) {
    var out = this;
    var promise = new Promise(function (resolve, reject) {
      out.on("error", reject).on(EVENT_FINISH, function (result) {
        resolve(result);
      });
    });

    return Promise.resolve(promise).then(fn, fnErr);
  },

  catch: function (fnErr) {
    return this.then(undefined, fnErr);
  },

  isVDOM: true,

  c: function (componentDef, key, customEvents) {
    this.h_ = componentDef;
    this.j_ = key;
    this.av_ = customEvents;
  }
};

proto.e = proto.element;
proto.be = proto.beginElement;
proto.ee = proto.aK_ = proto.endElement;
proto.t = proto.text;
proto.h = proto.w = proto.write = proto.html;

module.exports = AsyncVDOMBuilder;